import axiosInstance from '../variables/api/axiosInstance';
import i18n from '../i18n';
import { avecLibelleTraduit, libellesTraduits } from '../i18n/libelles';

/**
 * Échanges avec les partenaires : ce qui est envoyé à chaque compagnie et chaque bureau
 * homologue, ce qu'on attend d'eux, ce qu'on a reçu. Base des « États partenaires ».
 */

export const ROLES_PARTENAIRE = avecLibelleTraduit([
  { value: 'COMPAGNIE' },
  { value: 'BUREAU_HOMOLOGUE' },
], 'referentiels:rolesPartenaire');

export const libelleRole = (role) => (role === 'COMPAGNIE' ? i18n.t('referentiels:rolePartenaire.COMPAGNIE')
  : role === 'BUREAU_HOMOLOGUE' ? i18n.t('referentiels:rolePartenaire.BUREAU_HOMOLOGUE') : '-');

export const ETATS_ECHANGE = avecLibelleTraduit({
  ENVOYE: { color: 'default' },
  EN_ATTENTE: { color: 'gold' },
  EN_RETARD: { color: 'red' },
  REPONDU: { color: 'green' },
  RECU: { color: 'blue' },
}, 'referentiels:etatsEchange');

// Code → libellé, lu dans la langue courante (referentiels:naturesEchange).
// NB : EnvoiPartenaireModal en tire l'objet pré-rempli du courriel au partenaire.
export const NATURES_ECHANGE = libellesTraduits('referentiels:naturesEchange');

/** Ce qu'on envoie depuis un dossier (fenêtre « Envoyer au partenaire »). */
export const NATURES_ENVOI = avecLibelleTraduit([
  'TRANSMISSION_PV', 'DEMANDE_PIECES', 'OFFRE_INDEMNISATION', 'BAP', 'RECOURS', 'RELANCE', 'AUTRE',
].map((value) => ({ value })), 'referentiels:naturesEchange');

/** Organismes partenaires (compagnies et bureaux homologues), pour les listes de choix. */
export const chargerPartenaires = async () => {
  const [bureaux, compagnies] = await Promise.all([
    axiosInstance.get('/v1/organismes/type/BUREAU_HOMOLOGUE', { skipErrorToast: true }).then((r) => r.data?.data || []).catch(() => []),
    axiosInstance.get('/v1/organismes/type/COMPAGNIE_MEMBRE', { skipErrorToast: true }).then((r) => r.data?.data || []).catch(() => []),
  ]);
  return { bureaux, compagnies };
};

/** Options groupées : on choisit une compagnie OU un bureau homologue, en le voyant. */
export const optionsPartenaires = ({ bureaux = [], compagnies = [] } = {}) => [
  { label: i18n.t('referentiels:rolesPartenaire.COMPAGNIE'), options: compagnies.map((o) => ({ value: o.organismeTrackingId, label: o.raisonSociale, organisme: o })) },
  { label: i18n.t('referentiels:rolesPartenaire.BUREAU_HOMOLOGUE'), options: bureaux.map((o) => ({ value: o.organismeTrackingId, label: o.raisonSociale, organisme: o })) },
].filter((g) => g.options.length > 0);

export const echangesPartenaires = {
  dossier: (sinistreId) => axiosInstance.get(`/v1/etats-partenaires/dossier/${sinistreId}`),
  envoyer: (sinistreId, corps) => axiosInstance.post(`/v1/sinistres/${sinistreId}/echanges`, corps),
  reponseRecue: (courrierId, metadata, fichier) => {
    const fd = new FormData();
    fd.append('metadata', new Blob([JSON.stringify(metadata)], { type: 'application/json' }));
    if (fichier) fd.append('file', fichier);
    return axiosInstance.post(`/v1/courriers/${courrierId}/reponse-recue`, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
  },
  cloreAttente: (courrierId) => axiosInstance.post(`/v1/courriers/${courrierId}/attente/clore`),
};
